module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('i', [_vm._v("Forgiveness is nothing less than the way we heal the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz9-2"
    }
  }, [_vm._v("—B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISHOP")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESMOND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTU AND")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHO ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz9-3"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTU")]), _vm._v(", "), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORGIVING")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81c7272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 72
// module chunks = 0